import React, { useState } from 'react';
import LocationDetailsComponent from './LocationDetailsComponent';

const CriteriaSection = ({ items = {}, descriptions = {}, titles = {}, locationDetails, statusConfig }) => {
    const [isOpen, setIsOpen] = useState({});

    const toggleAccordion = (key) => {
        setIsOpen(prevState => ({ ...prevState, [key]: !prevState[key] }));
    };

    const defaultStatusConfig = {
        true: { className: 'text-success', icon: 'bi bi-check-circle-fill' },
        false: { className: 'text-danger', icon: 'bi bi-x-circle-fill' },
    };

    const statusMap = statusConfig
        ? { ...defaultStatusConfig, ...statusConfig }
        : defaultStatusConfig;

    const entries = Object.entries(items || {});

    if (entries.length === 0) {
        return (
            <div className="accordion">
                <div className="accordion-item border-top-0">
                    <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button">
                            Aucun critère disponible pour cette section.
                        </button>
                    </h2>
                </div>
            </div>
        );
    }

    return (
        <div className="accordion">

            {entries.map(([key, value]) => {
                const statusKey = value === true ? 'true' : 'false';
                const status = statusMap[statusKey] || defaultStatusConfig.false;

                return (
                <div className="accordion-item border-top-0" key={key}>
                    <h2 className="accordion-header" id={`heading-${key}`}>
                        <button
                            className={`accordion-button ${isOpen[key] ? '' : 'collapsed'}`}
                            type="button"
                            onClick={() => toggleAccordion(key)}
                            aria-expanded={isOpen[key]}
                            aria-controls={`collapse-${key}`}
                        >

                            <span className={`${status.className} me-1`}>
                                <i className={status.icon}></i>
                            </span>
                            <span>{titles && titles[key] ? titles[key] : 'Critère inconnu'}</span>
                        </button>
                    </h2>
                    <div
                        id={`collapse-${key}`}
                        className={`accordion-collapse collapse ${isOpen[key] ? 'show' : ''}`}
                        aria-labelledby={`heading-${key}`}
                        data-bs-parent="#criteriaAccordion"
                    >
                        <div className="accordion-body">
                            {descriptions[key]}

                            {/* Détails de localisation par critère si disponibles */}
                            {locationDetails && locationDetails[key] && (
                                <LocationDetailsComponent
                                    locationDetails={locationDetails[key]}
                                    criteriaName={key}
                                />
                            )}



                            {/* Affichage de la zone fausse si la valeur n'est pas true et qu'il y a un détail (legacy) */}
                            {value !== true && typeof value === 'string' && value.trim() !== '' && (
                                <div className="mt-3 p-2 border border-danger bg-light text-danger rounded">
                                    <strong>Zone fausse :</strong>
                                    <div style={{whiteSpace: 'pre-wrap'}}>{value}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                );
            })}

        </div>
    );
};

const CriteriaComponent = ({ mandatory, optional, bonus, mandatoryDescriptions, optionalDescriptions, bonusDescriptions, mandatoryTitles, optionalTitles, bonusTitles, locationDetails }) => {
    const [activeTab, setActiveTab] = useState('mandatory');

    // Fonction utilitaire pour vérifier si tous les critères sont valides
    const areAllValid = (criteria) => {
        return criteria && Object.values(criteria).every(value => value === true);
    };

    const hasAnyBonus = bonus && Object.values(bonus).some(value => value === true);

    const safeMandatory = mandatory || {};
    const safeOptional = optional || {};
    const safeBonus = bonus || {};

    return (
        <div className="mb-2">

            <nav className="nav nav-pills mb-0 justify-content-center">

                    <button className={`nav-link rounded-bottom-0 ${activeTab === 'mandatory' ? 'active' : ''}`} onClick={() => setActiveTab('mandatory')}>
                        <i className="bi bi-record-circle-fill text-danger"></i> Obligatoires
                        {areAllValid(safeMandatory) ? (
                            <i className="bi bi-check-circle-fill text-success ms-2"></i>
                        ) : (
                            <i className="bi bi-x-circle-fill text-danger ms-2"></i>
                        )}
                    </button>
                    <button className={`nav-link rounded-bottom-0 ${activeTab === 'optional' ? 'active' : ''}`} onClick={() => setActiveTab('optional')}>
                        <i className="bi bi-record-circle-fill text-success"></i> Complémentaire
                        {areAllValid(safeOptional) ? (
                            <i className="bi bi-check-circle-fill text-success ms-2"></i>
                        ) : (
                            <i className="bi bi-x-circle-fill text-danger ms-2"></i>
                        )}
                    </button>
                    <button className={`nav-link rounded-bottom-0 ${activeTab === 'bonus' ? 'active' : ''}`} onClick={() => setActiveTab('bonus')}>
                        <i className="bi bi-record-circle-fill text-info"></i> Bonus
                        {areAllValid(safeBonus) ? (
                            <i className="bi bi-check-circle-fill text-success ms-2"></i>
                        ) : (
                            <i className="bi bi-x-circle-fill text-danger ms-2"></i>
                        )}
                    </button>

            </nav>

            <div className="tab-content">
                <div className="tab-pane show fade active">

                    {activeTab === 'mandatory' && (
                        <CriteriaSection
                            items={safeMandatory}
                            descriptions={mandatoryDescriptions}
                            titles={mandatoryTitles}
                            locationDetails={locationDetails}
                        />
                    )}
                    {activeTab === 'optional' && (
                        <CriteriaSection
                            items={safeOptional}
                            descriptions={optionalDescriptions}
                            titles={optionalTitles}
                            locationDetails={locationDetails}
                        />
                    )}
                    {activeTab === 'bonus' && (
                        <CriteriaSection
                            items={safeBonus}
                            descriptions={bonusDescriptions}
                            titles={bonusTitles}
                            locationDetails={locationDetails}
                        />
                    )}

                </div>
            </div>


        </div>
    );
};

export default CriteriaComponent;
